<script>
    import { forEach } from 'lodash'
    import LiveFormula from './LiveFormula.vue'
    import EditableVariable from './EditableVariable.vue'

    export default {
        components: {},
        data: function() { return {
            //editableVariables: editableVariables
        }},
        mounted() {
            this.initEditableVariables()
            this.initLiveFormulas()
        },
        methods: {
            initEditableVariables() {
                this.$nextTick(() => {
                    if(this.$el.nodeName !== "#comment") {
                        let effectedWarningEnabled = false

                        if(this.effectedWarningEnabled) {
                            effectedWarningEnabled = this.effectedWarningEnabled
                        }

                        forEach(this.$el.querySelectorAll('.ec-inline-editable-variable'), function(el) {
                            let data = JSON.parse(el.innerHTML)
                            el.setAttribute('v-html', 'vContent')
                            
                            new EditableVariable({
                                data: function() { return {
                                    variableData: data,
                                    variable: data.id,
                                    value: data.value,
                                    decimals: data.decimals,
                                    orginalState: data.orginalState,
                                    min: data.min,
                                    max: data.max,
                                    effectedWarningEnabled: effectedWarningEnabled
                                }},
                            }).$mount(el)
                        })
                    }
                })
            },
            initLiveFormulas() {
                this.$nextTick(() => {
                    if(this.$el.nodeName !== "#comment") {
                        forEach(this.$el.querySelectorAll('.live-formula'), function(el) {
                            let data = JSON.parse(el.innerHTML)
                            el.setAttribute('v-html', 'lfContent')

                            new LiveFormula({
                                data: function() { return {
                                    formula: data.id,
                                    value: data.value,
                                    decimals: data.decimals
                                }}
                            }).$mount(el)
                        })
                    }
                })
            }
        },
    }
</script>